import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "transfer" }
const _hoisted_2 = { class: "transfer__inner" }
const _hoisted_3 = { class: "transfer__header" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "transfer__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_refill = _resolveComponent("refill")!
  const _component_bank_transfer = _resolveComponent("bank-transfer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(['transfer__tab', {'active': (i === _ctx.selectedIndex)}]),
            onClick: ($event: any) => (_ctx.selectTab(i))
          }, _toDisplayString(tab.title), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(['transfer__refill',
                   'transfer__item',
                   {'transfer__item--active': _ctx.selectedIndex === 0}])
        }, [
          _createVNode(_component_refill)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['transfer__bank-transfer',
                   'transfer__item',
                   {'transfer__item--active': _ctx.selectedIndex === 1}])
        }, [
          _createVNode(_component_bank_transfer)
        ], 2)
      ])
    ])
  ]))
}